import React, { useState, useCallback, useRef, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  chat: { id: 'liveChatTitle', defaultMessage: 'Chat' },
  clearAll: { id: 'liveChatClearAll', defaultMessage: 'Clear all messages' },
  clearAllConfirm: {
    id: 'liveChatClearAllConfirm',
    defaultMessage: 'Clear all chat messages?',
  },
});

const ChatHeader = ({ occupantCount, isModerator, onClearAll }) => {
  const intl = useIntl();
  const [confirming, setConfirming] = useState(false);
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (confirming && confirmBtnRef.current) {
      confirmBtnRef.current.focus();
    }
  }, [confirming]);

  const handleClearClick = useCallback(() => {
    setConfirming(true);
  }, []);

  const handleConfirm = useCallback(() => {
    setConfirming(false);
    onClearAll?.();
  }, [onClearAll]);

  const handleCancel = useCallback(() => {
    setConfirming(false);
  }, []);

  return (
    <div className="live-chat-header">
      <span className="live-chat-header-title">
        {intl.formatMessage(messages.chat)}
      </span>
      <div className="live-chat-header-actions">
        {isModerator && !confirming && (
          <button
            className="live-chat-clear-all-btn"
            onClick={handleClearClick}
            aria-label={intl.formatMessage(messages.clearAll)}
            title={intl.formatMessage(messages.clearAll)}
            type="button"
          >
            🗑
          </button>
        )}
        {isModerator && confirming && (
          <div
            className="live-chat-clear-confirm"
            role="alertdialog"
            aria-label={intl.formatMessage(messages.clearAllConfirm)}
          >
            <span className="live-chat-clear-confirm-text">
              {intl.formatMessage(messages.clearAllConfirm)}
            </span>
            <button
              className="live-chat-clear-confirm-yes"
              onClick={handleConfirm}
              type="button"
              ref={confirmBtnRef}
            >
              ✓
            </button>
            <button
              className="live-chat-clear-confirm-no"
              onClick={handleCancel}
              type="button"
            >
              ✕
            </button>
          </div>
        )}
        {occupantCount > 0 && (
          <span className="live-chat-header-viewers">
            <span className="live-chat-viewer-icon">{occupantCount}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;
